import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/claims/help/")({
  component: WhatsCovered,
  loader: () => {
    throw redirect({ to: "/claims/help/allowance" });
  },
});

function WhatsCovered() {
  return null;
}
